import { getUrl } from "./config";
import { store } from "./store";

export async function post(endpoint:string, body:any) {
  const url = `${getUrl()}${endpoint}`;
  console.log("url: " + url);
  const result = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });
  const resultJson = await result.json();

  console.log("result: " + JSON.stringify(resultJson));
  return resultJson;
}
export async function deleteRequest(endpoint:string, body:any) {
  const url = `${getUrl()}${endpoint}`;
  console.log("url: " + url);
  const result = await fetch(url, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });
  const resultJson = await result.json();

  console.log("result: " + JSON.stringify(resultJson));
  return resultJson;
}
export async function putRequest(endpoint:string, body:any) {
  const url = `${getUrl()}${endpoint}`;
  console.log("url: " + url);
  const result = await fetch(url, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });
  const resultJson = await result.json();

  console.log("result: " + JSON.stringify(resultJson));
  return resultJson;
}

export async function get(endpoint:string) {
  const url = `${getUrl()}${endpoint}`;
  console.log("url: " + url);
  const result = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });

  console.log("result: " + JSON.stringify(result));
  return result;
}

export async function deleteCard(card:any, sessionId:string)
{
  deleteRequest("card",
  {
    card: card,
    sessionId: sessionId,
  });
}
export async function updateCard(card:any, sessionId:string)
{
  putRequest("card",
  {
    card: card,
    sessionId: sessionId,
  });
}

//warm up server (because its heroku free tier)
export async function warmUp() {
  await get("");
}

export async function sync(sessionId:string){
  store.state.isSyncing = true;
  const result= await post("sync",{
    sessionId: sessionId
  })
  store.state.isSyncing  = false;
  return result;
}
